import * as React from "react";
import { Box, Container, Grid, Link, Stack, Typography } from "@mui/material";
import { LocationOn as LocationOnIcon, Phone as PhoneIcon } from "@mui/icons-material";

// Dark site footer with company details, quick links and legal links.
export default function SiteFooter() {
  return (
    <Box
      component="footer"
      sx={{ 
        bgcolor: '#191b1d', 
        color: 'white',
        py: 6,
        px: 4
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{ mb: 2 }}
            >
              Sateri Electronic Services
            </Typography>
            <Typography
              variant="body1"
              color="#cccccc"
              sx={{ mb: 3, lineHeight: 1.6 }}
            >
              Sateri Electronics Services is a premier provider specializing in POS software development,
              along with a key focus on sales and services of Trucount billing machines. 
              Our tailored solutions are designed to elevate business operations, offering user-friendly 
              interfaces and robust functionality.
            </Typography>
            
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <LocationOnIcon sx={{ mr: 1, color: '#cccccc' }} />
              <Typography color="#cccccc">
                KOLHAPUR
              </Typography>
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <PhoneIcon sx={{ mr: 1, color: '#cccccc' }} />
              <Typography color="#cccccc">
                +91 - 9822412353 / +91 - 8459583479 
              </Typography>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ mb: 2 }}
            >
              Quick Links
            </Typography>
            <Stack spacing={1}>
              <Link href="/" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                {'>'} About
              </Link>
              <Link href="/" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                {'>'} Services
              </Link>
              <Link href="/billingMachines" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                {'>'} Billing Machines
              </Link>
              <Link href="/noteCountingMachines" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                {'>'} Note Counting
              </Link>
              <Link href="/billzapp" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                {'>'} BillZapp
              </Link>
              <Link href="/products" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                {'>'} Products
              </Link>
              <Link href="/" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                {'>'} Contact 
              </Link>
            </Stack>
          </Grid>

          {/* Legal Links */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ mb: 2 }}
            >
              Legal
            </Typography>
            <Stack spacing={1}>
              <Link href="/terms-and-conditions" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                Terms and Conditions
              </Link>
              <Link href="/privacy-policy" color="#cccccc" underline="none" sx={{ '&:hover': { color: 'white' } }}>
                Privacy Policy
              </Link>
            </Stack>
            
            <Box sx={{ mt: 4 }}>
              <Typography variant="body2" color="#cccccc">
                {"Copyright © "}
                <Link color="inherit" href="/" underline="none">
                  sateriservices.com
                </Link>{" "}
                {new Date().getFullYear()}
                {"."}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        
        
      </Container>
    </Box>
  );
}
